import React from 'react';
import cx from 'classnames';

import s from './Burger.module.sass';

type BurgerProps = {
  opened: boolean
  className?: string
};

const Burger = React.forwardRef<HTMLDivElement, BurgerProps>(({
  opened,
  className,
}, ref) => {
  const compoundClassName = cx(s.root, { [s.active]: opened }, className);

  return (
    <div className={compoundClassName} ref={ref}>
      <span className={s.item} />
      <span className={s.item} />
      <span className={s.item} />
    </div>
  );
});

export default Burger;
